import { FC } from 'react';

import { Auth0Provider } from '@auth0/auth0-react';
import { createBrowserHistory } from 'history';

import { SuccessfulSignupMessage } from '@evinced-private/ui-common';

import {
	getProductToRedirectFromUrl,
	PRODUCT_TO_REDIRECT_PARAM
} from './helpers/InvitationTokenHelper';
import { getHomepagePath, getLoginSuccessPath } from './helpers/RoutesHelper';
import { sendPageView } from './services/analytics/HubspotService';
import { setRedirectToPath } from './services/LoginRedirectionService';
import { App } from './App';

const domain = process.env.AUTH0_EVINCED_DOMAIN;
const clientId = process.env.AUTH0_CLIENT_ID;
const audience = process.env.AUTH0_EVINCED_API_AUDIENCE;
const productToRedirectAfterLogin = getProductToRedirectFromUrl();

const history = createBrowserHistory();

export const AppContainer: FC = () => {
	// using the history object as an aspect for google analytics page views
	history.listen((location) => {
		sendPageView(location.pathname);
	});

	const onRedirectCallback = (appState): void => {
		history.push({
			pathname: getLoginSuccessPath() || appState?.returnTo || window.location.pathname,
			search: ''
		});
	};

	if (productToRedirectAfterLogin) {
		const redirectToUrl = `${getHomepagePath()}?${PRODUCT_TO_REDIRECT_PARAM}=${productToRedirectAfterLogin}`;
		setRedirectToPath(redirectToUrl);
	}

	const searchParams = new URLSearchParams(window.location.search);
	const error = searchParams.get('error');
	const errorDescription = searchParams.get('error_description');
	if (
		(error === 'unauthorized' || error === 'access_denied') &&
		errorDescription?.includes('verify your email')
	) {
		return <SuccessfulSignupMessage />;
	}

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			authorizationParams={{
				redirect_uri: window.location.origin,
				audience,
				scope: 'read:current_user openid profile user_metadata'
			}}
			onRedirectCallback={onRedirectCallback}
		>
			<App history={history} />
		</Auth0Provider>
	);
};
